import { render, staticRenderFns } from "./Horario2.vue?vue&type=template&id=a2955748"
import script from "./Horario2.vue?vue&type=script&lang=js"
export * from "./Horario2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports